module.exports = __webpack_public_path__ + "static/media/txt.d33718f7.svg";